module.exports = __webpack_public_path__ + "img/arrowGo.42bf72ff.svg";